'use client'

import { useAction } from 'next-safe-action/hooks'
import { UseFormReturn } from 'react-hook-form'

import { resetPassword } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

import { TResetPasswordForm } from '../model/form'

export const useResetPassword = ({
  form,
  onSuccess,
}: {
  form: UseFormReturn<TResetPasswordForm>
  onSuccess: () => void
}) => {
  const { handleServerError } = useServerErrorHandler(form)

  const action = useAction(resetPassword, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  return action
}
